import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../../AuthContext';
import { AppBar, Toolbar, Typography, Button } from '@mui/material';
import packageJson from '../../../package.json';

function Navbar() {
  const navigate = useNavigate();
  const { userRole, logout } = useContext(AuthContext);
  
  const handleLogout = async () => {
    await logout(navigate);
	navigate('/login', { state: { message: 'Du er nu logget ud' } });
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <Typography
          variant="h6"
          sx={{ flexGrow: 1, cursor: 'pointer' }}
          onClick={() => navigate('/dashboard')}
        >
          Recycon
		<Typography variant="caption">
          &nbsp;v{packageJson.version}
        </Typography>
        </Typography>
		{userRole === 'admin' && (
			<>
			<Button color="inherit" onClick={() => navigate('/users')}>
			  Brugere
			</Button>
			<Button color="inherit" onClick={() => navigate('/timeregadmin')}>
			  Ændre tider
			</Button>
			</>
        )}
        <Button color="inherit" onClick={() => navigate('/time')}>
          Tid
        </Button>
        <Button color="inherit" onClick={() => navigate('/profile')}>
          Profil
        </Button>
        <Button color="inherit" onClick={handleLogout}>
          Log ud
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default Navbar;
